import React from "react";

export default function ReservationPopup() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-xl shadow-lg px-8 py-6 text-center space-y-4 animate-fadeIn">
        <div className="text-lg font-medium">Finding Reservations</div>
        <img
          src="/loader.svg"  
          alt="Loading"
          className="w-16 h-16 mx-auto"
        />
      </div>
    </div>
  );
}
